import { render, staticRenderFns } from "./CatalogArticles.vue?vue&type=template&id=60babb1e"
import script from "./CatalogArticles.vue?vue&type=script&lang=js"
export * from "./CatalogArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports